// ============================================================
// SheetSwitch - an on/off fact, drawn as a switch.
//
// A real checkbox underneath (role="switch"), inside its label: the
// keyboard, a screen reader and a test all work it as a checkbox.
// ============================================================
import type { ReactNode } from 'react';
import styles from './Sheet.module.css';

interface Props {
  label: ReactNode;
  checked: boolean;
  onChange: (on: boolean) => void;
  disabled?: boolean;
  title?: string;
  /** A note after the label: "(talent)". */
  hint?: ReactNode;
}

export default function SheetSwitch({ label, checked, onChange, disabled, title, hint }: Props) {
  return (
    <label className={styles.switch} title={title}>
      <input
        type="checkbox"
        role="switch"
        checked={checked}
        disabled={disabled}
        onChange={(e) => onChange(e.target.checked)}
      />
      <span className={checked ? undefined : styles.switchOff}>{label}</span>
      {hint && <span className={styles.hint}>{hint}</span>}
    </label>
  );
}
